
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/webaccessibilitychecklist/done",
      function () {
        return require("private-next-pages/download/webaccessibilitychecklist/done/index.tsx");
      }
    ]);
  